import React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { gridUnit } from "../../styles";
import * as styles from "./styles";

const { Root, Portal } = PopoverPrimitive;

export type ContentProps = Pick<
  PopoverPrimitive.PopoverContentProps,
  "children" | "side" | "collisionPadding" | "sideOffset" | "className"
>;

const Content = ({
  side,
  children,
  sideOffset = gridUnit * 2,
  collisionPadding = gridUnit * 2,
}: ContentProps) => (
  <Portal>
    <PopoverPrimitive.Content
      side={side}
      className={styles.content}
      sideOffset={sideOffset}
      collisionPadding={collisionPadding}
    >
      <PopoverPrimitive.Arrow className={styles.arrow} />
      {children}
    </PopoverPrimitive.Content>
  </Portal>
);

const Trigger = ({ children }: { children: React.ReactNode }) => (
  <PopoverPrimitive.Trigger className={styles.trigger}>
    {children}
  </PopoverPrimitive.Trigger>
);

export { Root, Trigger, Content };
